import React, { Component } from 'react';

import Links from '../Tools/links';
import Carousel from '../Tools/Carousel';
import { SCALES } from '../../utils/constants/middleSchoolScales';
import { FILE } from '../../utils/constants/pdf';

class BandMiddle extends Component {
  state = {
    imageList: [
      {
        img: 'https://i.ytimg.com/vi/5jo4217X9o0/maxresdefault.jpg',
        school: 'Byrd Middle School',
      },
      {
        img:
          'https://res.cloudinary.com/dwvrok1le/image/upload/v1547230961/wax.jpg',
        school: 'Howard Junior High School',
      },
    ],
    scales: [
      { title: 'Flute', href: SCALES.flute },
      { title: 'Oboe', href: SCALES.oboe },
      { title: 'Bassoon', href: SCALES.bassoon },
      { title: 'Clarinet', href: SCALES.clarinet },
      { title: 'Bass Clarinet', href: SCALES.bassClarinet },
      { title: 'Alto / Bari Sax', href: SCALES.altoBariSax },
      { title: 'Tenor Saxophone', href: SCALES.tenorSaxophone },
      { title: 'Trumpet', href: SCALES.trumpet },
      { title: 'French Horn', href: SCALES.frenchHorn },
      { title: 'Trombone / Euphonium', href: SCALES.tbnEuph },
      { title: 'Tuba', href: SCALES.tuba },
    ],
    region: [
      {
        title: '2020 Middle School All-Region Materials',
        href: FILE.msAudition2020,
      },
    ],
  };
  render() {
    const { files } = this.props;
    return (
      <div className="band_middle scroll">
        <h2 className="band_title">Middle School</h2>
        <Carousel imageList={this.state.imageList} />
        <div className="band_high_sub">
          <div className="band_high_btm">
            <div>
              <h3>Solo & Ensemble</h3>
              <Links input={files.middleSolo} />
            </div>
            <div>
              <h3>Concert</h3>
              <Links input={files.middleConcert} />
            </div>
            <div>
              <h3>Region</h3>
              <Links input={this.state.region} />
            </div>
            <div>
              <h3>Scales</h3>
              <Links input={this.state.scales} />
            </div>
          </div>
          <div className="border_line" />
          <div className="band_high_btm">
            <h3>Contest Schedules</h3>
            <Links input={files.schedules.slice(2)} />
          </div>
        </div>
      </div>
    );
  }
}

export default BandMiddle;



// WEBPACK FOOTER //
// ./src/Components/Band/BandMiddle.js